import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { shallowEqual } from '@adalo/utils'

import canvasContext from 'contexts/CanvasContext'
import { computeLayout } from '../../../../utils/flexbox'
import { getComponent, getNestedComponentsMap } from '../../../../ducks/apps'
import { updateObject } from '../../../../ducks/editor/objects'
import BaseObject from '../BaseObject'
import ComponentRenderer from './ComponentRenderer'

class ComponentInstance extends BaseObject {
  static contextType = canvasContext

  isNestedComponentInstance = true

  shouldComponentUpdate(newProps) {
    const props = [
      'component',
      'hideShadows',
      'xScaled',
      'yScaled',
      'width',
      'height',
      'otherComponents',
    ]

    for (const prop of props) {
      if (!shallowEqual(newProps[prop], this.props[prop])) {
        return true
      }
    }

    return false
  }

  renderObjects() {
    const {
      id,
      component,
      width,
      height,
      hideShadows,
      otherComponents,
      updateObject,
    } = this.props

    if (!component) {
      return null
    }

    const computedLayout = computeLayout(
      component,
      width,
      height,
      otherComponents
    )

    if (!computedLayout) {
      return null
    }

    const [layout, computedHeight] = computedLayout

    if (!this.isNestedComponentInstance) {
      if (computedHeight !== height) {
        window.setTimeout(() => {
          updateObject(id, { height: computedHeight })
        }, 0)
      }
    }

    const wrapper = (component.layout.body || [])[0]
    const objects = (wrapper && wrapper.children) || []

    return (
      <g className="component-instance-objects">
        {objects.map(obj => (
          <ComponentRenderer
            key={obj.id}
            object={obj}
            hideShadows={hideShadows}
            layout={layout}
          />
        ))}
      </g>
    )
  }

  render() {
    const { xScaled, yScaled, width, height, zoom } = this.props
    const transform = `translate(${xScaled}, ${yScaled}) scale(${zoom.scale})`

    return (
      <g className="component-instance" transform={transform}>
        {this.renderObjects()}
        <rect
          x={0}
          y={0}
          width={width}
          height={height}
          fill="transparent"
          onMouseDown={this.handleMouseDown}
          onDoubleClick={this.handleDoubleClick}
        />
      </g>
    )
  }
}

const mapStateToProps = (state, { match, componentId }) => {
  const { appId } = match.params
  const component = getComponent(state, appId, componentId)

  return {
    component,
    otherComponents: getNestedComponentsMap(state, appId, component),
  }
}

export default withRouter(
  connect(mapStateToProps, { updateObject })(ComponentInstance)
)
